'use es6';

import { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SidebarHeader from 'ContentEditorUI/components/sidebar/SidebarHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SidebarWrapper = styled.div.withConfig({
  displayName: "Sidebar__SidebarWrapper",
  componentId: "sc-1p6x9fh-0"
})(["overflow:hidden;height:100%;"]);
const SidebarContent = styled.div.withConfig({
  displayName: "Sidebar__SidebarContent",
  componentId: "sc-1p6x9fh-1"
})(["display:flex;flex-direction:column;flex-grow:1;border-right:", ";width:380px;height:100%;", " overflow-y:hidden;overflow-x:hidden;"], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-disabled']};`, ({
  theme
}) => `background: ${theme.color['fill-surface-default']};`);
const SidebarBody = styled.div.withConfig({
  displayName: "Sidebar__SidebarBody",
  componentId: "sc-1p6x9fh-2"
})(["display:flex;flex-grow:1;position:relative;width:100%;min-height:0;"]);
export default class Sidebar extends Component {
  render() {
    return /*#__PURE__*/_jsx(SidebarWrapper, {
      children: /*#__PURE__*/_jsxs(SidebarContent, {
        id: "sidebar-content",
        children: [/*#__PURE__*/_jsx(SidebarHeader, {}), /*#__PURE__*/_jsx(SidebarBody, {
          children: this.props.children
        })]
      })
    });
  }
}
Sidebar.propTypes = {
  children: PropTypes.node.isRequired
};